import { createSlice } from '@reduxjs/toolkit'

import { IBalace } from '@/app/(global)/wallet/components/WalletInfo'

import { IDeposit } from './wallet.type'

const initialState = {
  isBuyETH: '',
  data: { chainId: '', name: '', tokens: [{}] } as IDeposit,
  balance: {} as IBalace,
  deposit: '',
}

const BuyETHSlice = createSlice({
  name: 'buysell',
  initialState,
  reducers: {
    setBuyETH: (state, action) => {
      state.isBuyETH = action.payload
    },
    setBalance: (state, action) => {
      state.balance = action.payload
    },
    setDeposit: (state, action) => {
      state.deposit = action.payload
    },
  },
  extraReducers: () => {},
})

export const BuyETHActions = BuyETHSlice.actions
const buyETHReducer = BuyETHSlice.reducer
export default buyETHReducer
